import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { marked } from "marked";
import api from "../lib/api";
import Seo from "../components/Seo";

export default function JournalPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    setPost(null); setError(null);
    api.get(`/blog/${slug}`).then(({ data }) => setPost(data)).catch(() => setError("Post not found"));
  }, [slug]);

  if (error) return (
    <main className="max-w-2xl mx-auto px-6 py-32 text-center">
      <h1 className="font-serif text-3xl">Post not found</h1>
      <Link to="/journal" className="btn-ghost mt-6 inline-flex">Back to journal</Link>
    </main>
  );
  if (!post) return <main className="py-32 text-center text-neutral-500">Loading…</main>;

  const html = marked.parse(post.body || "");
  const ld = {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: post.title,
    image: post.cover_image,
    datePublished: post.created_at,
    dateModified: post.updated_at,
    author: { "@type": "Organization", name: "Aura & Co." },
    publisher: { "@type": "Organization", name: "Aura & Co." },
    description: post.seo_description || post.excerpt,
  };

  return (
    <main className="max-w-3xl mx-auto px-6 md:px-8 py-14" data-testid="journal-post">
      <Seo title={post.seo_title || post.title}
           description={post.seo_description || post.excerpt}
           image={post.cover_image} type="article" jsonLd={ld} />
      <Link to="/journal" className="eyebrow text-neutral-500 hover:text-[var(--gold)]">← Journal</Link>
      <h1 className="font-serif text-4xl md:text-6xl mt-4 leading-tight" data-testid="post-title">{post.title}</h1>
      <p className="text-sm text-neutral-500 mt-3">{new Date(post.created_at).toLocaleDateString("en-GB", { year: "numeric", month: "long", day: "numeric" })}</p>
      {post.cover_image && (
        <div className="aspect-[16/10] bg-sand my-10 overflow-hidden">
          <img src={post.cover_image} alt={post.title} className="w-full h-full object-cover" />
        </div>
      )}
      <article
        className="prose-aura font-light text-base md:text-lg leading-relaxed text-neutral-800"
        dangerouslySetInnerHTML={{ __html: html }}
      />
    </main>
  );
}
